import * as Stimulus from "@hotwired/stimulus"

export class AllergyDetailsController extends Stimulus.Controller {
    static targets = ["trigger", "detailsFieldset", "detailsInput"]
    static values = {
        triggerValue: String,
        hiddenClass: { type: String, default: "hidden" },
    }

    connect() {
        this.sync()
    }

    sync() {
        if (!this.hasDetailsFieldsetTarget || !this.hasDetailsInputTarget) {
            return
        }

        const showDetails = this.triggerTargets.some(
            input => input.value === this.triggerValueValue && input.checked
        )

        this.detailsFieldsetTarget.classList.toggle(this.hiddenClassValue, !showDetails)
        this.detailsFieldsetTarget.setAttribute("aria-hidden", (!showDetails).toString())
        this.detailsInputTarget.disabled = !showDetails
        this.detailsInputTarget.required = showDetails
    }
}
